import { ErrorMessage } from '@hookform/error-message';
import { yupResolver } from '@hookform/resolvers/yup';
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useForm } from 'react-hook-form';
import toast from "react-hot-toast";
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { Tooltip as ReactTooltip } from "react-tooltip";
import addIcon from '../../assets/images/add-icon.svg';
import calLogo from '../../assets/images/calender.svg';
import Checkbox from "../../components/layouts/CheckBox";
import Button from '../../components/ui/Button';
import CustomReactSelect from "../../components/ui/CustomReactSelect";
import PageLayout from "../../components/ui/PageLayout";
import { ApiConstants } from "../../constants/ApiConstants";
import { ApiTypes, FREQUENCY_TYPES, HOUSEHOLD_TYPES, PERMISSIONS } from "../../constants/Constants";
import { Routes } from "../../constants/RouteConstants";
import authContext from "../../context/authContext";
import useMakeRequest from "../../utils/ApiHelper";
import { checkPermission, getChoresDiffrence, getFrequencyValue, isDateRangeFinalized, setDateHelper } from "../../utils/Helper";
import { FrequencyTypesJson, MonthTypesJson, WeekTypesJson } from "../../utils/JSON";
import AddChoresValidation from "../../validations/chores/AddChores";
import ChoresList from "./ChoresList";



interface householdInputs {
    hh_id: string,
    s_date: string;
    e_date: string,
    h_spent: string,
    cc_id: string,
    d_by: string,
    f_type: string,
    f_value: string | null,
    is_f_s: boolean,
    description: string;
    status: number
    s_days_or_months?: number[]
};

const Chores = () => {

    let profile: any = useContext(authContext);
    profile = profile?.data;
    const navigate = useNavigate();
    const hhList: any = useMakeRequest();
    const hhMembers = useMakeRequest();
    const choresCateg = useMakeRequest();
    const choresCreate = useMakeRequest();
    const [choresOptions, setChoresOptions] = useState([{ value: '', label: '', price: '' }]);
    const [doneByOptions, setDoneByOptions] = useState([{ value: '', label: '' }]);
    const [finalizedMonths, setFinalizedMonths] = useState([]);
    const [choresName, setChoresName]: any = useState('');
    const [doneByName, setDoneByName]: any = useState('');
    const [choresList, setChoresList]: any = useState([]);
    const [isRefresh, setIsRefresh] = useState(false)
    const [isExpanded, setIsExpanded] = useState(false);
    const [status, setStatus] = useState({ value: 3, label: 'Completed' });
    const [closeAfterSave, setCloseAfterSave] = useState(false);


    const [selectedChoresValues, setSelectedChoresValues]: any = useState({
        cc_id: null,
        d_by: null,
        f_type: { value: FrequencyTypesJson?.[0]?.value, label: FrequencyTypesJson?.[0]?.label }
    })


    const { register, watch, setValue, formState: { errors }, handleSubmit, trigger, resetField, reset } = useForm<householdInputs>({
        mode: 'onChange',
        defaultValues: {
            f_type: String(FREQUENCY_TYPES?.ONCE_ONLY),
            h_spent: ""
        },
        resolver: yupResolver(AddChoresValidation)
    });

    useEffect(() => {
        setValue('s_date', setDateHelper({ date: moment().toDate() }))
    }, [])
    useEffect(() => {
        if (watch('f_type') !== String(FREQUENCY_TYPES?.ONCE_ONLY)) {
            setValue('f_value', "1")
        }
    }, [watch('f_type')])



    useEffect(() => {
        if (choresCateg?.status) {
            const transformedData = choresCateg?.data?.data?.map((item: any) => ({
                value: item?.uuid,
                label: item?.name,
                price: item?.national_cost,
            }));
            setChoresOptions(transformedData);
        }
    }, [choresCateg?.status]);

    useEffect(() => {
        if (hhMembers?.status) {
            const transformedData = hhMembers?.data?.data?.map((item: any) => ({
                value: item?.user?.uuid,
                label: profile?.uuid === item?.user?.uuid ? `Me` : item?.user?.name
            }));
            const selectedItem = transformedData?.find((item: any) => item.value === profile?.uuid);
            console.log("selectedItem: ", selectedItem)
            // Set it if found
            if (selectedItem) {
                setSelectedChoresValues({ ...selectedChoresValues, d_by: selectedItem })
                setValue('d_by', selectedItem.value);
                trigger('d_by')
            }
            setDoneByOptions(transformedData);
        }
    }, [hhMembers?.status]);

    useEffect(() => {
        if (!checkPermission(profile?.plan_perms, PERMISSIONS?.BASIC_CHORES)) {
            navigate(Routes?.Dashboard)
        }
        hhList.makeRequest({ url: ApiConstants?.GetHousehold, payload: { show_all: true } })
        choresCateg.makeRequest({ url: ApiConstants?.ChoresCategories, type: ApiTypes?.GET })
    }, [])

    useEffect(() => {
        if (watch('hh_id')) {
            hhMembers.makeRequest({ url: ApiConstants?.GetHouseholdMembers, payload: { hh_id: watch('hh_id') } })
        }
    }, [watch('hh_id')])

    useEffect(() => {
        if (hhList?.status) {
            setValue('hh_id', hhList?.data?.data?.[0]?.value)
        }
    }, [hhList?.status])

    useEffect(() => {
        const sDate = watch('s_date');
        const eDate = watch('e_date');
        const fType = watch('f_type');
        const fValue = watch('f_value');
        const hSpent = watch('h_spent');
        const ccId = watch('cc_id');

        if (sDate && eDate && fType && fValue && hSpent && ccId) {
            const resultDates = getChoresDiffrence({
                date1: sDate,
                date2: eDate,
                frequencyType: fType,
                frequencyValue: fValue,
                selectedDays: watch('s_days_or_months')
            });

            const choresArr = resultDates?.map((d) => {
                return {
                    date: d,
                    hour_spent: watch('h_spent'),
                    chores: choresName,
                    done_by: doneByName
                }
            });
            setChoresList(choresArr)
        }
    }, [watch('s_date'), watch('e_date'), watch('f_type'), watch('f_value'), watch('h_spent'), watch('cc_id'), watch('s_days_or_months')])

    useEffect(() => {
        if (choresList?.length > 0) {
            let ttlAmnt = 0;
            let ttlHrs = 0;
            choresList.forEach((c: any) => {
                ttlAmnt += ttlAmnt;
                ttlHrs += Number(c?.hour_spent);
            });

        }
    }, [choresList])

    const handleSelectDaysOrMonths = (value: any, type: any) => {
        let prevSelected: any = watch('s_days_or_months');
        if (prevSelected.includes(value)) {
            prevSelected = prevSelected.filter((item: any) => item !== value);
        } else {
            prevSelected = [...prevSelected, value];
        }
        setValue('s_days_or_months', prevSelected)
        trigger('s_days_or_months')
    };

    const onSubmit = (formInputs: householdInputs) => {
        const payload = {
            ...formInputs,
            status: status.value,
            e_date: formInputs?.e_date ? formInputs?.e_date : formInputs?.s_date,
        }
        const isAlreadyFinalized = isDateRangeFinalized(payload?.s_date, payload?.e_date, finalizedMonths);
        if (isAlreadyFinalized) {
            toast.error('The selected month is already finalized.')
            return;
        }
        payload.f_type = payload?.f_type === String(FREQUENCY_TYPES?.YEARLY) ? String(FREQUENCY_TYPES?.MONTHLY) : payload.f_type;
        toast.promise(
            choresCreate.makeRequest({ payload, url: ApiConstants?.ChoresCreate }),
            {
                loading: 'Processing...',
                success: (data: any) => data.message,
                error: (error: any) => error.message,
            }
        );

        if (closeAfterSave) {
            setIsExpanded(false);
        }

        setCloseAfterSave(false);
        // reset();
    }

    useEffect(() => {
        if (choresCreate?.status) {
            // choresCreate.reset();
            setValue('s_date', setDateHelper({ date: moment().toDate() }))
            setValue('e_date', '')
            setValue('h_spent', '')
            setValue('cc_id', '')
            setValue('f_type', String(FREQUENCY_TYPES?.ONCE_ONLY))
            setValue('f_value', null)
            setValue('description', '')
            setStatus({ value: 3, label: 'Completed' })
            setValue('s_days_or_months', [])
            setSelectedChoresValues({
                cc_id: null,
                d_by: null,
                f_type: { value: FrequencyTypesJson?.[0]?.value, label: FrequencyTypesJson?.[0]?.label }
            })
            hhMembers.makeRequest({ url: ApiConstants?.GetHouseholdMembers, payload: { hh_id: watch('hh_id') } })
        }
    }, [choresCreate?.status])

    const handleRefresh = async () => {
        return new Promise(async (resolve: any) => {
            setIsRefresh(true)
            setValue('s_date', '')
            setValue('e_date', '')
            setValue('h_spent', '')
            setValue('cc_id', '')
            setValue('d_by', '')
            setValue('f_type', String(FREQUENCY_TYPES?.ONCE_ONLY))
            setValue('f_value', null)
            setValue('s_days_or_months', [])
            setSelectedChoresValues({
                cc_id: null,
                d_by: null,
                f_type: { value: FrequencyTypesJson?.[0]?.value, label: FrequencyTypesJson?.[0]?.label }
            })
            await hhList.makeRequest({ url: ApiConstants?.GetHousehold, payload: { show_all: true } })
            await choresCateg.makeRequest({ url: ApiConstants?.ChoresCategories, type: ApiTypes?.GET })
            await hhMembers.makeRequest({ url: ApiConstants?.GetHouseholdMembers, payload: { hh_id: watch('hh_id') } })
            setIsRefresh(false)
            resolve();
        });
    }


    return (
        <PageLayout headerName='Chores' onlyTitle={false} onRefresh={handleRefresh}>
            <div className="page-padding-x my-3">
                <div className="payment-form">
                    <div
                        className="form-header"
                        role="button"
                        tabIndex={0}
                        onClick={() => setIsExpanded(!isExpanded)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                setIsExpanded(!isExpanded);
                            }
                        }}
                    >
                        <h2 className="dropdown-title">Add Chores</h2>
                        <img
                            src={addIcon}
                            alt="Arrow"
                            className="arrow-icon"
                        />
                    </div>

                    {isExpanded && (
                        <form onSubmit={handleSubmit(onSubmit)} className={choresCreate?.loading ? 'disabled-ct' : ''}>
                            <div className='page-padding-x mt-3'>
                                {/* <h2 className="form-title">Add Chores</h2> */}
                                <div className='row mb-4 g-3'>
                                    <div className='col-12'>
                                        <CustomReactSelect
                                            label="Household"
                                            options={hhList?.data?.data}
                                            value={{ value: hhList?.data?.data?.[0]?.value, label: hhList?.data?.data?.[0]?.label }}
                                            className="com-r-select"
                                            classNamePrefix="com-r-select"
                                            placeholder="Please select household name"
                                            onChange={(selectedOption) => {
                                                setValue("hh_id", selectedOption ? selectedOption.value : "");
                                                trigger("hh_id")
                                            }}
                                            closeMenuOnScroll={true}
                                            closeMenuOnSelect={true}
                                            isLoading={hhList?.loading}
                                            error={errors}
                                            errorName="hh_id"
                                        />
                                        {/* <div className="com-input-grp">
                                            <label className="form-label">Household</label>
                                            <div className='custom-select'>
                                                <Select
                                                    options={hhList?.data?.data}
                                                    value={{ value: hhList?.data?.data?.[0]?.value, label: hhList?.data?.data?.[0]?.label }}
                                                    className="com-r-select"
                                                    classNamePrefix="com-r-select"
                                                    placeholder="Please select household name"
                                                    onChange={(selectedOption) => {
                                                        setValue("hh_id", selectedOption ? selectedOption.value : "");
                                                        trigger("hh_id")
                                                    }}
                                                    closeMenuOnScroll={true}
                                                    closeMenuOnSelect={true}
                                                    isLoading={hhList?.loading}
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    name="hh_id"
                                                    render={({ message }) => <p className='valid-error'>{message}</p>}
                                                />
                                            </div>
                                        </div> */}
                                    </div>
                                    <div className='col-12'>
                                        <CustomReactSelect
                                            required
                                            label="Chore Type"
                                            value={selectedChoresValues?.cc_id}
                                            options={choresOptions}
                                            className="com-r-select"
                                            classNamePrefix="com-r-select"
                                            placeholder="Category"
                                            isLoading={choresCateg?.loading}
                                            onChange={(selectedOption) => {
                                                setSelectedChoresValues({ ...selectedChoresValues, cc_id: selectedOption })
                                                setValue("cc_id", selectedOption ? selectedOption.value : "");
                                                trigger("cc_id")
                                                setChoresName(selectedOption?.label)
                                            }}
                                            error={errors}
                                            errorName="cc_id"
                                            closeMenuOnScroll={true}
                                            closeMenuOnSelect={true}
                                            tooltip={
                                                {
                                                    content: 'Select a chore.',
                                                    id: 'select-chore',
                                                    place: 'bottom',
                                                }
                                            }
                                        />
                                        {/* <div className="com-input-grp">
                                            <label className="form-label">Chore Type <span className="label-star">*</span>
                                                <abbr
                                                    data-tooltip-id={"select-chore"}
                                                    className="text-decoration-none cursor-pointer"
                                                >
                                                    {" "}
                                                    <i className="icon-info ms-2"></i>
                                                </abbr></label>
                                            <ReactTooltip
                                                style={{
                                                    zIndex: "1",
                                                    wordBreak: "break-word",
                                                    maxWidth: "90%",
                                                }}
                                                id={"select-chore"}
                                                place="bottom"
                                                content={"Select a chore."}
                                            />
                                            <div className='custom-select'>
                                                <Select
                                                    value={selectedChoresValues?.cc_id}
                                                    options={choresOptions}
                                                    className="com-r-select"
                                                    classNamePrefix="com-r-select"
                                                    placeholder="Category"
                                                    isLoading={choresCateg?.loading}
                                                    onChange={(selectedOption) => {
                                                        setSelectedChoresValues({ ...selectedChoresValues, cc_id: selectedOption })
                                                        setValue("cc_id", selectedOption ? selectedOption.value : "");
                                                        trigger("cc_id")
                                                        setChoresName(selectedOption?.label)
                                                    }}
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    name="cc_id"
                                                    render={({ message }) => <p className='valid-error'>{message}</p>}
                                                />
                                            </div>
                                        </div> */}
                                    </div>
                                    {
                                        watch('f_type') == String(FREQUENCY_TYPES?.ONCE_ONLY) ?
                                            <>
                                                <div className='col-12 col-sm-6'>
                                                    <div className="com-input-grp">
                                                        <label className="form-label d-block">Date <span className="label-star">*</span></label>
                                                        <DatePicker
                                                            className='form-control'
                                                            placeholderText="MM/DD/YYYY"
                                                            timeFormat="MM DD YYYY"
                                                            onKeyDown={(e: any) => e.preventDefault()}
                                                            showYearDropdown
                                                            scrollableYearDropdown
                                                            yearDropdownItemNumber={50}
                                                            selected={watch('s_date') ? moment(watch('s_date')).toDate() : moment().toDate()}
                                                            showIcon
                                                            icon={<><img className="calIcon" src={calLogo} alt="" /></>}
                                                            onChange={(start_date: any) => {
                                                                setValue('s_date', setDateHelper({ date: start_date }))
                                                                trigger('s_date')
                                                                setValue('e_date', '')
                                                            }}
                                                            minDate={
                                                                profile?.hh_member?.member_type == HOUSEHOLD_TYPES?.ADMIN ?
                                                                    moment(profile?.hh_member?.billing_date).toDate() :
                                                                    moment(profile?.hh_member?.created_at).toDate()
                                                            }
                                                        />

                                                        <ErrorMessage
                                                            errors={errors}
                                                            name="s_date"
                                                            render={({ message }) => <p className='valid-error'>{message}</p>}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                            : ''}


                                    <div className='col-12 col-sm-6'>
                                        <div className="com-input-grp">
                                            <label className="form-label" htmlFor="h_spent">Hours <span className="label-star">*</span>
                                                <abbr
                                                    data-tooltip-id={"enter-hours"}
                                                    className="text-decoration-none cursor-pointer"
                                                >
                                                    {" "}
                                                    <i className="icon-info ms-2"></i>
                                                </abbr>
                                            </label>
                                            <ReactTooltip
                                                style={{
                                                    zIndex: "1",
                                                    wordBreak: "break-word",
                                                    maxWidth: "90%",
                                                }}
                                                id={"enter-hours"}
                                                place="bottom"
                                                content={"Hours"}
                                            />
                                            <input
                                                id="h_spent"
                                                type="text"
                                                className={`form-control ${errors?.h_spent ? 'is-invalid' : ''}`}
                                                placeholder='Hours'
                                                max={24}
                                                min={0}
                                                aria-invalid={!!errors?.h_spent}
                                                aria-describedby={errors?.h_spent ? "h_spent-error" : undefined}
                                                value={watch('h_spent')}
                                                onInput={(e: any) => {
                                                    let value = e.target.value.replace(/[^0-9.]/g, '');
                                                    if (value === '') {
                                                        setValue('h_spent', '');
                                                        return;
                                                    }
                                                    const [hours, minutes] = value.split('.');
                                                    if (parseInt(hours) > 24) {
                                                        value = '24';
                                                    }
                                                    if (minutes) {
                                                        if (minutes.length > 2) {
                                                            value = `${hours}.${minutes.substring(0, 2)}`;
                                                        }
                                                        if (parseInt(minutes[0]) > 5) {
                                                            value = `${hours}.5`;
                                                        } else if (minutes.length === 2 && parseInt(minutes) > 59) {
                                                            value = `${hours}.59`;
                                                        }
                                                    }
                                                    e.target.value = value;
                                                    setValue('h_spent', value);
                                                    trigger('h_spent');
                                                }}

                                            />
                                            <ErrorMessage
                                                errors={errors}
                                                name="h_spent"
                                                render={({ message }) => (
                                                    <p id="h_spent-error" className='valid-error' tabIndex={0} role="alert" aria-live="polite">
                                                        {message}
                                                    </p>
                                                )}
                                            />
                                        </div>
                                    </div>



                                    <div className="col-6">
                                        <CustomReactSelect
                                            required
                                            label="Status"
                                            value={status}
                                            options={[{ value: 1, label: "Unassigned" }, { value: 2, label: "Assigned" }, { value: 3, label: "Completed" },]}
                                            className="com-r-select"
                                            classNamePrefix="com-r-select"
                                            placeholder="Select"
                                            onChange={(selectedOption: any) => {
                                                setStatus(selectedOption);
                                            }}
                                            error={errors}
                                            errorName="Status"
                                            closeMenuOnScroll={true}
                                            closeMenuOnSelect={true}
                                        />
                                    </div>

                                    {status?.value !== 1 &&
                                        <div className='col-6'>
                                            <CustomReactSelect
                                                label="Member"
                                                value={selectedChoresValues?.d_by}
                                                options={doneByOptions}
                                                className="com-r-select"
                                                classNamePrefix="com-r-select"
                                                placeholder="Member"
                                                isLoading={hhMembers?.loading}
                                                onChange={(selectedOption) => {
                                                    setSelectedChoresValues({ ...selectedChoresValues, d_by: selectedOption })
                                                    setValue("d_by", selectedOption ? selectedOption.value : "");
                                                    setDoneByName(selectedOption?.label)
                                                    trigger("d_by")
                                                }}
                                                closeMenuOnScroll={true}
                                                closeMenuOnSelect={true}
                                                error={errors}
                                                errorName="d_by"
                                            />
                                            {/* <div className="com-input-grp">
                                                <label className="form-label">Member</label>
                                                <div className='custom-select'>
                                                    <Select
                                                        // defaultValue={selectedOption}
                                                        value={selectedChoresValues?.d_by}
                                                        options={doneByOptions}
                                                        className="com-r-select"
                                                        classNamePrefix="com-r-select"
                                                        placeholder="Member"
                                                        isLoading={hhMembers?.loading}
                                                        onChange={(selectedOption) => {
                                                            setSelectedChoresValues({ ...selectedChoresValues, d_by: selectedOption })
                                                            setValue("d_by", selectedOption ? selectedOption.value : "");
                                                            setDoneByName(selectedOption?.label)
                                                            trigger("d_by")
                                                        }}
                                                    />
                                                    <ErrorMessage
                                                        errors={errors}
                                                        name="d_by"
                                                        render={({ message }) => <p className='valid-error'>{message}</p>}
                                                    />
                                                </div>
                                            </div> */}
                                        </div>
                                    }

                                    <div className="col-12">
                                        <div className="com-input-grp">
                                            <label className="form-label">Description</label>
                                            <div className='custom-select'>
                                                <input type="text" className="form-control" placeholder='Type here' max={24} min={0} value={watch('description')}
                                                    onInput={(e: any) => {
                                                        let value = e.target.value
                                                        if (value === '') {
                                                            setValue('description', '');
                                                            trigger('description');
                                                            return;
                                                        }
                                                        setValue('description', value);
                                                        trigger('description');
                                                    }}
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    name="description"
                                                    render={({ message }) => <p className='valid-error'>{message}</p>}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-12'>
                                        <CustomReactSelect
                                            required
                                            label="Frequency Type"
                                            value={selectedChoresValues?.f_type}
                                            options={FrequencyTypesJson}
                                            className="com-r-select"
                                            classNamePrefix="com-r-select"
                                            placeholder="Frequency type"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                            }}
                                            onChange={(selectedOption) => {
                                                if (selectedOption?.value === String(FREQUENCY_TYPES?.MONTHLY)) {
                                                    const monthArr: any = []
                                                    MonthTypesJson?.map(({ value }) => {
                                                        monthArr.push(value)
                                                    })
                                                    setValue('s_days_or_months', monthArr)
                                                    trigger('s_days_or_months')
                                                } else {
                                                    setValue('s_days_or_months', [])
                                                    trigger('s_days_or_months')
                                                }
                                                setSelectedChoresValues({ ...selectedChoresValues, f_type: selectedOption })
                                                setValue("f_type", selectedOption ? selectedOption.value : "");

                                                trigger("f_type")
                                                trigger("s_date")
                                            }}
                                            closeMenuOnScroll={true}
                                            closeMenuOnSelect={true}
                                            error={errors}
                                            errorName="f_type"
                                        />
                                        {/* <div className="com-input-grp">
                                            <label className="form-label">Frequency Type <span className="label-star">*</span></label>
                                            <div className='custom-select'>
                                                <Select
                                                    value={selectedChoresValues?.f_type}
                                                    options={FrequencyTypesJson}
                                                    className="com-r-select"
                                                    classNamePrefix="com-r-select"
                                                    placeholder="Frequency type"
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    }}
                                                    onChange={(selectedOption) => {
                                                        if (selectedOption?.value === String(FREQUENCY_TYPES?.MONTHLY)) {
                                                            const monthArr: any = []
                                                            MonthTypesJson?.map(({ value }) => {
                                                                monthArr.push(value)
                                                            })
                                                            setValue('s_days_or_months', monthArr)
                                                            trigger('s_days_or_months')
                                                        } else {
                                                            setValue('s_days_or_months', [])
                                                            trigger('s_days_or_months')
                                                        }
                                                        setSelectedChoresValues({ ...selectedChoresValues, f_type: selectedOption })
                                                        setValue("f_type", selectedOption ? selectedOption.value : "");

                                                        trigger("f_type")
                                                        trigger("s_date")
                                                    }}
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    name="f_type"
                                                    render={({ message }) => <p className='valid-error'>{message}</p>}
                                                />
                                            </div>
                                        </div> */}
                                    </div>

                                    {
                                        watch('f_type') !== String(FREQUENCY_TYPES?.ONCE_ONLY) ?
                                            <>
                                                {
                                                    watch('f_type') === String(FREQUENCY_TYPES?.WEEKLY) ?
                                                        <div className='col-12'>
                                                            <div className="com-input-grp mb-4 mt-2">
                                                                <label className="form-label">Day of the Week</label>
                                                            </div>
                                                            <div className="row gy-4">
                                                                {WeekTypesJson?.map((week, weekIndex) => (
                                                                    <div className="col-6" key={weekIndex}>
                                                                        <div className="form-check com-check">
                                                                            <Checkbox
                                                                                id={week?.label}
                                                                                labelText={week?.label}
                                                                                checked={watch('s_days_or_months')?.includes(week?.value)}
                                                                                onChange={() => handleSelectDaysOrMonths(week?.value, FREQUENCY_TYPES?.WEEKLY)}
                                                                            />
                                                                            {/* <input type="checkbox" className="form-check-input" id={week?.label} onChange={() => handleSelectDaysOrMonths(week?.value, FREQUENCY_TYPES?.WEEKLY)} checked={watch('s_days_or_months')?.includes(week?.value)} /> */}
                                                                            {/* <label className="form-check-label fw-500" htmlFor={week?.label}>{week?.label}</label> */}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                                <ErrorMessage
                                                                    errors={errors}
                                                                    name="s_days_or_months"
                                                                    render={({ message }) => <p className='valid-error'>{message}</p>}
                                                                />
                                                            </div>
                                                        </div>
                                                        : (watch('f_type') === String(FREQUENCY_TYPES?.MONTHLY) || watch('f_type') === String(FREQUENCY_TYPES?.YEARLY)) ?
                                                            <div className='col-12'>
                                                                <div className="com-input-grp mb-4 mt-2">
                                                                    <label className="form-label">Month of the Year</label>
                                                                </div>
                                                                <div className="row gy-4">
                                                                    {MonthTypesJson?.map((month, monthIndex) => (
                                                                        <div className="col-6" key={monthIndex}>
                                                                            <div className="form-check com-check">
                                                                                <Checkbox
                                                                                    id={month?.label}
                                                                                    labelText={month?.label}
                                                                                    checked={watch('s_days_or_months')?.includes(month?.value)}
                                                                                    onChange={() => handleSelectDaysOrMonths(month?.value, FREQUENCY_TYPES?.MONTHLY)}
                                                                                />
                                                                                {/* <input type="checkbox" className="form-check-input" id={month?.label} onChange={() => handleSelectDaysOrMonths(month?.value, FREQUENCY_TYPES?.MONTHLY)} checked={watch('s_days_or_months')?.includes(month?.value)} />
                                                                                <label className="form-check-label fw-500" htmlFor={month?.label}>{month?.label}</label> */}
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        name="s_days_or_months"
                                                                        render={({ message }) => <p className='valid-error'>{message}</p>}
                                                                    />
                                                                </div>
                                                            </div>
                                                            : ""
                                                }

                                                <div className='col-12 col-sm-6'>
                                                    <div className="com-input-grp">
                                                        <label className="form-label d-block">Start Date</label>
                                                        <DatePicker
                                                            className='form-control'
                                                            placeholderText="MM/DD/YYYY"
                                                            timeFormat="MM DD YYYY"
                                                            onKeyDown={(e: any) => e.preventDefault()}
                                                            showYearDropdown
                                                            scrollableYearDropdown
                                                            yearDropdownItemNumber={50}
                                                            // selected={watch("s_date") as any}
                                                            selected={watch('s_date') ? moment(watch('s_date')).toDate() : null}
                                                            showIcon
                                                            icon={<><img className="calIcon" src={calLogo} alt="" /></>}
                                                            onChange={(start_date: any) => {
                                                                setValue('s_date', setDateHelper({ date: start_date }))
                                                                trigger('s_date')
                                                                setValue('e_date', '')
                                                            }}
                                                            minDate={
                                                                profile?.hh_member?.member_type == HOUSEHOLD_TYPES?.ADMIN ?
                                                                    moment(profile?.hh_member?.billing_date).toDate() :
                                                                    moment(profile?.hh_member?.created_at).toDate()
                                                            }
                                                        />
                                                        <ErrorMessage
                                                            errors={errors}
                                                            name="s_date"
                                                            render={({ message }) => <p className='valid-error'>{message}</p>}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-12 col-sm-6'>
                                                    <div className="com-input-grp">
                                                        <label className="form-label d-block">End Date</label>
                                                        <DatePicker
                                                            className='form-control'
                                                            placeholderText="MM/DD/YYYY"
                                                            timeFormat="MM DD YYYY"
                                                            onKeyDown={(e: any) => e.preventDefault()}
                                                            showYearDropdown
                                                            scrollableYearDropdown
                                                            yearDropdownItemNumber={50}
                                                            // selected={watch("e_date") as any}
                                                            selected={watch('e_date') ? moment(watch('e_date')).toDate() : null}
                                                            showIcon
                                                            icon={<><img className="calIcon" src={calLogo} alt="" /></>}
                                                            onChange={(start_date: any) => {
                                                                setValue('e_date', setDateHelper({ date: start_date }))
                                                                trigger('e_date')
                                                            }}
                                                            // minDate={new Date(watch('s_date')+1)}
                                                            minDate={new Date(new Date(watch('s_date')).setDate(new Date(watch('s_date')).getDate() + 1))}
                                                        />
                                                        <ErrorMessage
                                                            errors={errors}
                                                            name="e_date"
                                                            render={({ message }) => <p className='valid-error'>{message}</p>}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-12'>
                                                    <div className="com-input-grp">
                                                        <label className="form-label">Interval
                                                            <abbr
                                                                data-tooltip-id={"select-interval"}
                                                                className="text-decoration-none cursor-pointer"
                                                            >
                                                                {" "}
                                                                <i className="icon-info ms-2"></i>
                                                            </abbr>
                                                        </label>
                                                        <ReactTooltip
                                                            style={{
                                                                zIndex: "1",
                                                                wordBreak: "break-word",
                                                                maxWidth: "90%",
                                                            }}
                                                            id={"select-interval"}
                                                            place="bottom"
                                                            content={"Interval"}
                                                        />
                                                        <div className='custom-select'>
                                                            <Select
                                                                options={getFrequencyValue({ type: watch('f_type'), sDate: watch('s_date'), eDate: watch('e_date') })}
                                                                className="com-r-select"
                                                                classNamePrefix="com-r-select"
                                                                placeholder="Interval value"
                                                                isDisabled={!watch("s_date") || !watch("e_date")}
                                                                value={watch('f_value') ? { value: watch('f_value'), label: watch('f_value') } : { value: 1, label: 1 }}
                                                                onChange={(selectedOption) => {
                                                                    setValue("f_value", selectedOption ? String(selectedOption.value) : "");
                                                                    trigger("f_value");
                                                                }}
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                }}
                                                            />
                                                            <ErrorMessage
                                                                errors={errors}
                                                                name="f_value"
                                                                render={({ message }) => <p className='valid-error'>{message}</p>}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            : ''}
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Button
                                        className="com-btn com-btn-outline mt-2 mb-4"
                                        style={{ width: "50%" }}
                                        type="submit"
                                        text="submit"
                                        loading={choresCreate?.loading}
                                        onClick={() => setCloseAfterSave(false)}
                                    >
                                        Save & Add Another
                                    </Button>

                                    <Button
                                        style={{ width: "50%" }}
                                        onClick={() => setCloseAfterSave(true)}
                                        type="submit"
                                        className="com-btn mt-2 mb-4"
                                    >
                                        Save
                                    </Button>

                                </div>

                                {/* <Button className='com-btn mt-2 mb-4' style={{ width: "100%" }} type="submit" text="submit" loading={choresCreate?.loading}>Submit</Button> */}
                            </div >
                        </form >
                    )}
                </div>
            </div>

            <ChoresList
                doneByOptions={doneByOptions}
                statusOptions={status}
                choresOptions={choresOptions}
                choresCreate={choresCreate}
                setFinalizedMonths={setFinalizedMonths}
                isRefresh={isRefresh}
                setIsRefresh={setIsRefresh}
            />
        </PageLayout>
    )
}

export default Chores;